export default class Paths {
  // static ObjectToQueryParams = (payload: Maybe<{ [key: string | number | symbol]: string | number | [string] }>) => {
  static ObjectToQueryParams = (payload: Object) => {
    if (!payload) return '';
    const queryArray = [] as string[];
    Object.keys(payload).forEach((e) => {
      const data = payload[e];
      if (typeof data === 'string' && data) queryArray.push(`${e}=${data}`);
      else if (typeof data === 'number') queryArray.push(`${e}=${data + ''}`);
      else if (Array.isArray(data) && data.length) queryArray.push(`${e}=${data.join(',')}`);
    });
    return queryArray.join('&');
  };

  static Main = class {
    static index = () => {
      return {
        route: '/',
        name: 'passenger',
      };
    };
  };
  static Dashboard = class {
    static index = () => {
      return {
        route: '/',
        name: 'dashboard',
      };
    };
  };
  static Profile = class {
    static index = () => {
      return { route: '/profile', name: 'profile' };
    };
  };
  static Miles = class {
    static base = '/miles';
    static index = () => {
      return { route: `${this.base}/view`, name: 'miles' };
    };
    static new = () => {
      return { route: `${this.base}/new`, name: 'miles.new' };
    };
    static claim = () => {
      return { route: `${this.base}/claim`, name: 'miles.claim' };
    };
    static calculation = () => {
      return { route: `${this.base}/calculation`, name: 'miles.calculation' };
    };
  };
  static Tickets = class {
    static index = () => {
      return { route: '/tickets', name: 'tickets' };
    };
    static single = () => {
      return { route: (id) => `/tickets/${id}`, name: 'ticket' };
    };
  };
  static Login = class {
    static index = () => {
      return { route: '/login', name: 'login' };
    };
  };

  static ResetPassword = class {
    static index = () => {
      return { route: '/reset-password', name: 'resetPassword' };
    };
  };
  static Signup = class {
    static index = () => {
      return { route: '/signup', name: 'signUp' };
    };
  };
  static Supervision = class {
    static index = () => {
      return { route: '/supervision', name: 'supervision' };
    };
  };
  static Services = class {
    static index = () => {
      return { route: '/services', name: 'services' };
    };
    static transfer = () => {
      return { route: '/services/transfer-milage', name: 'transferMilage' };
    };
    static buyMilage = () => {
      return { route: '/services/buy-milage', name: 'buyMilage' };
    };
    static convertMilages = () => {
      return { route: '/services/convert-milage', name: 'convertMilage' };
    };
    static products = () => {
      return { route: '/services/products', name: 'products' };
    };
    static Card = () => {
      return {
        route: (id: string) => `/services/products/${id}/card`,
        routeText: `/services/products/:id/card`,
        name: 'merchants.card',
      };
    };
    static Booking = () => {
      return {
        route: `/services/products/booking`,
        routeText: `/services/products/booking`,
        name: 'product.booking',
      };
    };
    static identification = () => {
      return { route: '/services/identification-code', name: 'identification' };
    };
    static showHistory = () => {
      return { route: '/services/award-ticket/history', name: 'showHistory' };
    };
    static discount = () => {
      return { route: '/services/discount', name: 'discount' };
    };
    static discountBook = () => {
      return {
        route: '/services/discount/book',
        name: 'bookDiscount',
        routeAndQuery: (payload: Object) => {
          return `/services/discount/book${Paths.ObjectToQueryParams(payload)}`;
        },
      };
    };
    static showHistoryDiscount = () => {
      return { route: '/services/discount/history', name: 'showHistoryDiscount' };
    };
    static awardTicket = () => {
      return { route: '/services/award-ticket', name: 'AwardTicket' };
    };
    static awardTicketResult = () => {
      return { route: (id) => `/services/award-ticket/${id}`, name: 'AwardTicketResult' };
    };
    static awardTicketBook = () => {
      return {
        route: '/services/award-ticket/book',
        name: 'bookFlight',
        routeAndQuery: (payload: Object) => {
          return `/services/award-ticket/book${Paths.ObjectToQueryParams(payload)}`;
        },
      };
    };
  };
}
